import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["label", "subTitle", "showMask", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var CustomJoveLogo = function CustomJoveLogo(props) {
  var width = props.width,
      height = props.height;
  return /*#__PURE__*/_jsxs("svg", {
    width: width || 31,
    height: height || 40,
    viewBox: "0 0 386 502",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M197.184 102.875V393.093C197.184 447.134 133.575 492.684 86.314 492.684V499.083C120.692 499.083 186.143 492.684 214.791 479.859C243.887 467.467 266.776 448.243 284.413 423.025C301.602 397.808 310.405 366.165 310.405 328.15V102.875C310.405 75.6512 316.135 52.8474 328.042 34.0295C339.472 15.6183 369.125 6.39917 385.419 6.39917V0H122.171V6.39917C138.465 6.39917 168.088 15.6183 179.547 34.0295C191.007 52.8474 197.184 75.6512 197.184 102.875Z",
      fill: "#202020"
    }), /*#__PURE__*/_jsx("path", {
      d: "M72.0709 445.129C111.402 445.129 143.286 414.933 143.286 377.685C143.286 340.437 111.402 310.241 72.0709 310.241C32.7397 310.241 0.855469 340.437 0.855469 377.685C0.855469 414.933 32.7397 445.129 72.0709 445.129Z",
      fill: "#0E35D1"
    })]
  });
};

var SUBTITLE_MESSAGES = ['Please wait while we load this page', "We're getting everything ready for you", "Just a moment — we'll be right with you", 'Thanks for your patience', 'Loading your experience'];

var JoveAnimatedLoadingView = function JoveAnimatedLoadingView(props) {
  var _props$label = props.label,
      label = _props$label === void 0 ? 'Please wait' : _props$label,
      subTitle = props.subTitle,
      _props$showMask = props.showMask,
      showMask = _props$showMask === void 0 ? true : _props$showMask,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded);

  var _useState = useState(0),
      messageIndex = _useState[0],
      setMessageIndex = _useState[1];

  var displaySubTitle = subTitle || SUBTITLE_MESSAGES[messageIndex];
  useEffect(function () {
    if (subTitle) return;
    var interval = setInterval(function () {
      return setMessageIndex(function (i) {
        return (i + 1) % SUBTITLE_MESSAGES.length;
      });
    }, 3500);
    return function () {
      return clearInterval(interval);
    };
  }, [subTitle]);
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
    className: clsx('fixed inset-0 z-40 flex items-center justify-center backdrop-blur-sm', {
      'bg-white/90': showMask
    }, className),
    style: {
      isolation: 'isolate'
    }
  }, rest), {}, {
    children: [/*#__PURE__*/_jsx("style", {
      children: "\n        /* \u2500\u2500\u2500 Logo breathing \u2500\u2500\u2500 */\n        @keyframes jove-breathe {\n          0%, 100% {\n            transform: scale(1);\n            opacity: 1;\n          }\n          50% {\n            transform: scale(1.07);\n            opacity: 0.88;\n          }\n        }\n\n        .jove-loading-logo {\n          animation: jove-breathe 3s cubic-bezier(0.45, 0, 0.55, 1) infinite;\n          transition: filter 0.3s ease;\n        }\n\n        .jove-loading-logo svg {\n          display: block;\n        }\n\n        /* \u2500\u2500\u2500 Progress bar sweep \u2500\u2500\u2500 */\n        @keyframes jove-progress-sweep {\n          0% {\n            transform: translateX(-100%);\n          }\n          50% {\n            transform: translateX(200%);\n          }\n          100% {\n            transform: translateX(200%);\n          }\n        }\n\n        .jove-progress-track {\n          width: 220px;\n          height: 3px;\n          background: #eef0f2;\n          border-radius: 999px;\n          overflow: hidden;\n        }\n\n        .jove-progress-bar {\n          height: 100%;\n          width: 45%;\n          border-radius: 999px;\n          background: linear-gradient(90deg, #0E35D1, #4060e0, #0E35D1);\n          background-size: 200% 100%;\n          animation: jove-progress-sweep 1.8s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n        }\n\n        /* \u2500\u2500\u2500 Loading dots staggered \u2500\u2500\u2500 */\n        @keyframes jove-dot-pulse {\n          0%, 20% {\n            opacity: 0.12;\n          }\n          50% {\n            opacity: 1;\n          }\n          80%, 100% {\n            opacity: 0.12;\n          }\n        }\n\n        .jove-dot {\n          display: inline-block;\n          animation: jove-dot-pulse 1.6s ease-in-out infinite;\n        }\n        .jove-dot:nth-child(1) { animation-delay: 0s; }\n        .jove-dot:nth-child(2) { animation-delay: 0.32s; }\n        .jove-dot:nth-child(3) { animation-delay: 0.64s; }\n\n        /* \u2500\u2500\u2500 Fade-in for text block \u2500\u2500\u2500 */\n        @keyframes jove-fade-up {\n          from {\n            opacity: 0;\n            transform: translateY(8px);\n          }\n          to {\n            opacity: 1;\n            transform: translateY(0);\n          }\n        }\n\n        .jove-loading-text {\n          animation: jove-fade-up 0.6s cubic-bezier(0.16, 1, 0.3, 1) both;\n        }\n\n        /* \u2500\u2500\u2500 Subtitle fade-in on message change \u2500\u2500\u2500 */\n        @keyframes subtitle-fade-in {\n          from {\n            opacity: 0;\n            transform: translateY(4px);\n          }\n          to {\n            opacity: 1;\n            transform: translateY(0);\n          }\n        }\n\n        .subtitle-fade-in {\n          animation: subtitle-fade-in 0.45s cubic-bezier(0.16, 1, 0.3, 1) both;\n        }\n\n        /* \u2500\u2500\u2500 Reduced motion \u2500\u2500\u2500 */\n        @media (prefers-reduced-motion: reduce) {\n          .jove-loading-logo {\n            animation: none;\n            opacity: 1;\n          }\n          .jove-progress-bar {\n            animation: none;\n            background: #0E35D1;\n            width: 30%;\n          }\n          .jove-dot {\n            animation: none;\n            opacity: 1;\n          }\n          .jove-loading-text {\n            animation: none;\n            opacity: 1;\n            transform: none;\n          }\n        }\n      "
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col items-center gap-9",
      children: [/*#__PURE__*/_jsx("div", {
        className: "jove-loading-logo",
        children: /*#__PURE__*/_jsx(CustomJoveLogo, {
          width: 44,
          height: 58
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "jove-progress-track",
        children: /*#__PURE__*/_jsx("div", {
          className: "jove-progress-bar"
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "jove-loading-text flex flex-col items-center gap-2",
        style: {
          animationDelay: '0.2s'
        },
        children: [/*#__PURE__*/_jsxs("p", {
          className: "text-[17px] font-semibold tracking-[-0.01em] text-[#292929]",
          children: [label, /*#__PURE__*/_jsx("span", {
            className: "jove-dot",
            children: "."
          }), /*#__PURE__*/_jsx("span", {
            className: "jove-dot",
            children: "."
          }), /*#__PURE__*/_jsx("span", {
            className: "jove-dot",
            children: "."
          })]
        }), /*#__PURE__*/_jsx("p", {
          className: "subtitle-fade-in text-[13px] font-medium tracking-[-0.01em] text-[#8e949f]",
          children: displaySubTitle
        }, messageIndex)]
      })]
    })]
  }));
};

export default JoveAnimatedLoadingView;